<template>
  <PropertyDetailsCard>
    <template #title>Leasing term & availability</template>
    <template #action>
      <PropertyDetailsCardEditButton v-if="hasInfo" @click="showModal" />
    </template>

    <PropertyTermsAndAvailabilityInfo :property="property" />
    <PropertyDetailsCardPlaceholder
      v-if="!hasInfo"
      class="placeholder"
      title="You haven't added terms and availability yet"
      subtitle="Set your lease conditions and availability to align with tenant expectations"
      button-text="Add terms & availability"
      @button-clicked="showModal"
    />
    <PropertyTermsAndAvailabilityModal ref="propertyTermsAndAvailabilityModalRef" />
  </PropertyDetailsCard>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue';

import { usePropertyStore } from '@tallo/investor/property';
import {
  PropertyDetailsCard,
  PropertyDetailsCardEditButton,
  PropertyDetailsCardPlaceholder,
  PropertyTermsAndAvailabilityInfo,
} from '@tallo/property';

import PropertyTermsAndAvailabilityModal from './property-terms-and-availability-modal.vue';

const { property } = usePropertyStore();
const propertyTermsAndAvailabilityModalRef = ref<InstanceType<typeof PropertyTermsAndAvailabilityModal>>();
const hasInfo = computed(() => {
  const leaseConditions = property?.leaseConditions;

  return leaseConditions?.desiredLeasingDate || Boolean(leaseConditions?.possibleLeaseTerms?.length);
});

function showModal() {
  propertyTermsAndAvailabilityModalRef.value?.modalRef?.show();
}
</script>
